<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill="currentColor"
    />
    <path
      d="M15.3337 8.66699L8.66699 15.3337M8.66699 8.66699L15.3337 15.3337"
      stroke="white"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
